export default "__VITE_ASSET__3K8KMG56__"